<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.8839 3.05534C11.9579 1.98163 13.6997 1.98148 14.7736 3.05534L16.9445 5.22721C18.0183 6.30112 18.0183 8.04295 16.9445 9.11686L9.11637 16.945C8.04254 18.0188 6.30167 18.0186 5.2277 16.945L3.05582 14.7731C1.98188 13.6992 1.98188 11.9584 3.05582 10.8844L10.8839 3.05534ZM13.7121 4.11588C13.224 3.62825 12.4325 3.62811 11.9445 4.11588L4.11637 11.945C3.62821 12.4331 3.62821 13.2244 4.11637 13.7126L6.28824 15.8844C6.77643 16.3723 7.56777 16.3725 8.05582 15.8844L8.93961 15.0006L7.46988 13.5309C7.177 13.238 7.17702 12.7633 7.46988 12.4704C7.76278 12.1775 8.23754 12.1775 8.53043 12.4704L10.0002 13.9401L11.4396 12.5006L10.9699 12.0309C10.677 11.738 10.677 11.2633 10.9699 10.9704C11.2628 10.6775 11.7375 10.6775 12.0304 10.9704L12.5002 11.4401L13.9396 10.0006L12.4699 8.53092C12.177 8.23804 12.177 7.76327 12.4699 7.47038C12.7628 7.17748 13.2375 7.17748 13.5304 7.47038L15.0002 8.9401L15.8839 8.05631C16.3719 7.56819 16.3719 6.77588 15.8839 6.28776L13.7121 4.11588Z"
            fill="currentColor"
        />
    </svg>
</template>
